export const DRAWER_WIDTH = 240;

export const topPriscribers = [
    {
        id: 1,
        name: 'Dr. John Ponugupati',
        subText: '10 Total Patient(s) this year'
    },
    {
        id: 2,
        name: 'Dr. Janet Thorley',
        subText: '9 Total Patient(s) this year'
    },
    {
        id: 3,
        name: 'Dr. Katherine Mitchell',
        subText: '8 Total Patient(s) this year'
    },
    {
        id: 4,
        name: 'Dr. Rajiv Khanna',
        subText: '7 Total Patient(s) this year'
    },
    {
        id: 5,
        name: 'Dr. Chaitanya Dave',
        subText: '6 Total Patient(s) this year'
    },
    {
        id: 6,
        name: 'Dr. Monte Martin',
        subText: '6 Total Patient(s) this year'
    },
    {
        id: 7,
        name: 'Dr. Arindam Bagchi',
        subText: '6 Total Patient(s) this year'
    },
    {
        id: 8,
        name: 'Dr. Justin Cohen',
        subText: '6 Total Patient(s) this year'
    },
    {
        id: 9,
        name: 'Dr. Rowena Gonzales-Chambers',
        subText: '6 Total Patient(s) this year'
    }
];

export const TABLE_DATA = [
    {
        channel: 'Banner Ad',
        vendor: 'Medscape',
        creative: 'Consideration',
        date: '01 March 2021',
        action: 'None'
    },
    {
        channel: 'Banner Ad',
        vendor: 'Medscape',
        creative: 'Consideration',
        date: '02 March 2021',
        action: 'View'
    },
    {
        channel: 'Email',
        vendor: 'Biopharm',
        creative: 'Clinical Trial and Patient Characterstics',
        date: '01 March 2021',
        action: 'Sent'
    },
    {
        channel: 'Sales Rep',
        vendor: 'Connexions360',
        creative: 'Efficacy, Safety & Dosing',
        date: '07 March 2021',
        action: 'Open'
    },
    {
        channel: 'Sales Rep',
        vendor: 'NuMedis',
        creative: 'Efficacy, Safety & Dosing',
        date: '07 March 2021',
        action: 'Impressions'
    },
    {
        channel: 'Sales Rep',
        vendor: 'Peer Direct',
        creative: 'Efficacy, Safety & Dosing',
        date: '07 March 2021',
        action: 'Click'
    }

];

export const TABLE_COLUMNS = [
    {
        key: 'engagement_type',
        value: 'Channel'
    },
    {
        key: 'creative',
        value: 'Creative'
    },
    {
        key: 'assets',
        value: 'Assets'
    },
    {
        key: 'action_date',
        value: 'Date'
    },
    {
        key: 'action',
        value: 'Action'
    }
    // 'Vendor',
    
    // 'Creative',
];


